module.exports = __webpack_public_path__ + "img/about_004.ed6f45f.webp";